module.exports = __webpack_public_path__ + "resources/img/img_document_recognizer_id_card_m_jp.919bcf6cf0d17d90e3d0808ea748f079.png";